export interface IRelationshipType {
  relationshipTypeId: number;
  name: string;
}

export class RelationshipTypeModel implements IRelationshipType {
  relationshipTypeId: number;
  name: string;

  constructor(
    params: Partial<IRelationshipType> = {} as RelationshipTypeModel,
  ) {
    const { relationshipTypeId = 0, name = '' } = params;

    this.relationshipTypeId = relationshipTypeId;
    this.name = name;
  }
}
